import moment from 'moment';

export enum TwoFAType {
  DUMMY = 0,
  EMAIL = 1,
  SMS = 2,
  AUTH_APP = 3,
  BACKUP_CODES = 31,
  EMAIL_MS_IDENTITY_CONFIRMATION = 32,
}

export type TwoFAMethodValue = string | null;

export interface TwoFAMethod {
  id: number;
  display_name: string | null;
  type: TwoFAType;
  value: TwoFAMethodValue[];
  enabled: boolean;
  // NOTE(mike): This property is defined by sso backend, but not used in
  // accounts. This is used on mobile.
  suggested_by_subscription: boolean;
  default: boolean;
  created: string;
}

export interface TwoFactorSecurityTokenData {
  token: string;
  validUntil: string;
}

export const TWO_FACTOR_CODE_LENGTH = 6;

export type TwoFactorSetupMethodType = TwoFAType.EMAIL | TwoFAType.AUTH_APP | TwoFAType.SMS;
export const TWO_FACTOR_SETUP_METHODS_BY_PRIORITY: TwoFactorSetupMethodType[] = [
  TwoFAType.EMAIL,
  TwoFAType.SMS,
  TwoFAType.AUTH_APP
];

export const methodTypeToIconMap = {
  [TwoFAType.AUTH_APP]: 'authenticate-shield-white',
  [TwoFAType.EMAIL]: 'email-message-white',
  [TwoFAType.SMS]: 'message-sms-white',
  [TwoFAType.BACKUP_CODES]: 'backup-codes-white',
  [TwoFAType.DUMMY]: '',
  [TwoFAType.EMAIL_MS_IDENTITY_CONFIRMATION]: 'email-message-white'
};

export function isSetupMethodType(methodType: TwoFAType): methodType is TwoFactorSetupMethodType {
  return TWO_FACTOR_SETUP_METHODS_BY_PRIORITY.includes(methodType as TwoFactorSetupMethodType);
}

export function hasSecurityTokenExpired(data: TwoFactorSecurityTokenData) {
  return moment.utc(data.validUntil).isBefore(moment.utc());
}

export function filterMethodsByTypes(methods: TwoFAMethod[], types: TwoFAType[]) {
  return methods.filter(method => types.includes(method.type));
}

export function findMethodByType(methods: TwoFAMethod[], type: TwoFAType) {
  return methods.find(method => method.type === type);
}
